import { runDetailsSlice } from '../RunDetailsSlice'
import useSliceWrapper from './useSliceWrapper'

const useGetMethodsAndData = () => useSliceWrapper('runDetails', runDetailsSlice)

export const useRunDetailsSlice = (): ReturnType<typeof useGetMethodsAndData> =>
  useGetMethodsAndData()

export default useRunDetailsSlice
